import { displayNotif } from 'hb-react/shared/helpers/notifications';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

export const toggleTopPosts = ({ type, itemId, userId }) => {
  const url =
    type === 'posts_feed_post'
      ? Routes.toggle_post_to_top_post_user_post_path(
          {
            user_id: userId,
          },
          itemId,
        )
      : Routes.toggle_post_to_top_post_user_location_path(
          {
            user_id: userId,
          },
          itemId,
        );

  return axios
    .put(url, {
      type,
    })
    .then(({ data }) => {
      displayNotif(
        'success',
        data.pinned_to_top_posts
          ? s__('TopPosts|Successfully added to Top Posts')
          : s__('TopPosts|Successfully removed from Top Posts'),
      );

      return data;
    })
    .catch(() => {
      displayNotif('error', __('Sorry, an error occurred'));
    });
};
